const COVER_ART_MAP = {
  CourseAssessment: '/images/course-assessment.svg',
  CourseAudio: '/images/course-audio.svg',
  CourseFile: '/images/course-file.svg',
  CoursePage: '/images/course-page.svg',
  CoursePost: '/images/course-post.svg',
  CourseUrl: '/images/course-url.svg',
  CourseVideo: '/images/course-video.svg',
  CourseCollection: '/images/course-collection.svg',
  CourseCurriculum: '/images/course-curriculum.svg',
};

export default ({ coverArt, courseType = 'CoursePage', courseSubtype = '' }) => {
  if (coverArt) return coverArt;

  let key = courseType;
  if (courseType === 'CourseSelfPost') key = 'CoursePost';
  if (['CourseEvolve', 'CourseScorm', 'CourseAicc', 'CourseLti'].includes(courseType)) key = 'CourseFile';
  if (courseType === 'CourseLiveVideo') key = 'CourseVideo';
  if (courseSubtype === 'video') key = 'CourseVideo';
  if (courseSubtype === 'audio') key = 'CourseAudio';

  const defaultImage = COVER_ART_MAP[key];

  return { url: { w550: defaultImage, w1600: defaultImage } };
};
